/*
 * Copyright (c) 2019 3will Corporation and others.
 * All rights reserved. This program and the accompanying materials
 * are made available under the terms of the 3will License v1.0
 * which accompanies this distribution, and is available at
 *
 *     http://www.3will.cn/licenses/license-v1.0
 *
 * Contributors:
 *    3will - initial API and implementation
 */
import { StyleSheet } from 'react-native';
import { TwTheme } from '@tw/tw-runtime-rn';
const theme = TwTheme.values;

export const styles = StyleSheet.create({
  //头部推按背景
  headerImage: {
    width: '100%',
    height: 203
  },
  //页面容器
  container: {},
  //快速导航区域
  courseContainer: {
    marginHorizontal: theme.spaces[4],
    paddingVertical: theme.spaces[3],
    paddingHorizontal: theme.spaces[6],
    marginBottom: 10,
    flex: 1,
    ...TwTheme.values.shadows.card,
    backgroundColor: '#ffffff',
    borderRadius: theme.radius.md,
    overflow: 'hidden',
    transform: [{ translateY: -10 }, { translateY: 0 }, { translateY: -10 }]
  },
  iconButton: {
    flex: 1,
    fontWeight: theme.textWeights.bold
  },
  //生日卡券区
  borthContainer: {
    marginHorizontal: theme.spaces[4],
    marginTop: theme.spaces[4]
  },
  borthCardContainer: {
    width: '100%',
    flex: 1,
    ...TwTheme.values.shadows.card
  },
  borthImage: {
    height: 162,
    borderTopLeftRadius: theme.radius.md,
    borderTopRightRadius: theme.radius.md
  },
  yyfwImage: {
    height: 180,
    borderTopLeftRadius: theme.radius.md,
    borderTopRightRadius: theme.radius.md
  },
  //节日商品选择区
  goodContainer: {
    marginHorizontal: theme.spaces[4]
  },
  cardContainer: {
    width: 136,
    height: 166,
    borderRadius: 8
  },
  image: {
    height: 110,
    borderTopLeftRadius: theme.radius.md,
    borderTopRightRadius: theme.radius.md
  },
  subtitle: {
    // TODO:增加主题规范
    color: '#F19D4F',
    fontWeight: theme.textWeights.bold,
    ...theme.textSizes.sm
  },
  subtitleTag: {
    lineHeight: 13,
    fontSize: 10,
    borderWidth: 1,
    borderColor: '#A4A4A4',
    color: '#A4A4A4',
    borderRadius: 2,
    paddingHorizontal: 4,
    alignItems: 'center'
  },
  //展示导航区卡片设置
  cardImage: {
    width: '100%',
    height: 156,
    borderRadius: theme.radius.md
  }
});
